var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89.462,
    height: 89.461,
    viewBox: "0 0 89.462 89.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3203",
    "data-name": "Rect\\xE1ngulo 3203",
    width: 36.716,
    height: 42,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Componente_1941_3",
    "data-name": "Componente 1941 \\u2013 3",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4567",
    "data-name": "Grupo 4567",
    transform: "translate(-688.5 -296.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 44.231,
    cy: 44.231,
    r: 44.231,
    transform: "translate(688.5 296.5)",
    fill: "#fff",
    stroke: "#65a518",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18388",
    "data-name": "Grupo 18388",
    transform: "translate(25.872 23.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18389",
    "data-name": "Grupo 18389",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18388-2",
    "data-name": "Grupo 18388",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13321",
    "data-name": "Trazado 13321",
    d: "M35.98,6.521,33.6,7.6a66.445,66.445,0,0,1,.6,8.931c0,16.364-13.222,22-15.815,22.959C15.738,38.53,2.513,32.9,2.513,16.533A65.367,65.367,0,0,1,3.444,5.42C4.53,4.7,8.655,2.513,18.359,2.513c8.242,0,12.448,1.575,14.2,2.491l2.64-1.2a2.37,2.37,0,0,0-.478-.444C33.214,2.35,28.614,0,18.359,0S3.5,2.352,2,3.363A2.413,2.413,0,0,0,.974,4.946,68.048,68.048,0,0,0,0,16.533C0,34.574,14.6,40.791,17.53,41.854a2.406,2.406,0,0,0,.829.146,2.452,2.452,0,0,0,.83-.145c2.928-1.064,17.528-7.281,17.528-25.322A68.419,68.419,0,0,0,35.98,6.521",
    transform: "translate(0 -0.001)",
    fill: "#006729"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13322",
    "data-name": "Trazado 13322",
    d: "M11.764,6.98l.481,14.432h2.984L15.681,6.98Z",
    transform: "translate(4.645 2.756)",
    fill: "#006729"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3204",
    "data-name": "Rect\\xE1ngulo 3204",
    width: 3.617,
    height: 3.495,
    transform: "translate(16.59 27.121)",
    fill: "#006729"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldModal);
export default __webpack_public_path__ + "static/media/shieldModal.4c9f784767cfe332bd1c4821b7fe9323.svg";
export { ForwardRef as ReactComponent };